import React from 'react';
import useIsMounted from 'ismounted';
import { DESTROY } from '../../variables';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import T from 'i18n-react';
import Typography from '@material-ui/core/Typography';
import type { QuestionProps } from '../Question';

const UploadQuestion = ({
  id,
  answerItems = [],
  answerItem = {},
  inputType,
  allowMultiple,
  isRequired,
  onChange,
  readOnly = false,
}: QuestionProps) => {
  const [fileName, setFileName] = React.useState();
  const isMounted = useIsMounted();

  const labelId = `business-question-${id}`;

  return (
    <div>
      <input
        type="file"
        id={labelId}
        style={{ display: 'none' }}
        multiple={allowMultiple}
        required={
          isRequired ||
          !(allowMultiple ? answerItems.length > 0 : answerItem.id)
        }
        accept={
          inputType === 'image'
            ? 'image/*,application/pdf'
            : 'audio/*,video/*,image/*,application/pdf'
        }
        onChange={(event) => {
          event.persist();
          if (allowMultiple) {
            //TODO: Support multiple mode
          } else {
            const file = event.target.files[0];
            setFileName(file.name);

            if (file) {
              const reader = new FileReader();
              reader.onload = () => {
                if (isMounted.current) {
                  const url = reader.result;
                  onChange?.(
                    {
                      answerItem: {
                        ...answerItem,
                        value: url,
                        ...!!answerItem.id,
                      },
                      valid: true,
                      file: true,
                    },
                    'single',
                  );
                }
              };
              reader.readAsDataURL(file);
            } else {
              onChange?.(
                {
                  answerItem: {
                    ...answerItem,
                    value: null,
                    ...(!!answerItem.id && {
                      [DESTROY]: !isRequired && !!answerItem.value,
                    }),
                  },
                  valid: !isRequired,
                  file: true,
                },
                'single',
              );
            }
          }
        }}
      />
      <Grid container spacing={2} alignItems="center" wrap="nowrap">
        {!readOnly && (
          <Grid item>
            <label htmlFor={labelId}>
              <Button
                variant="contained"
                color="primary"
                component="span"
                style={{ fontWeight: 'bold' }}
              >
                {T.translate('upload')}
              </Button>
            </label>
          </Grid>
        )}
        <Grid item xs zeroMinWidth>
          {!!fileName && <Typography noWrap>{fileName}</Typography>}
        </Grid>
      </Grid>
    </div>
  );
};

export default UploadQuestion;
